const routes = [{
  // 巡更记录列表
  path: '/reserve/reserveRecord',
  name: 'reserveRecord',
  component: () => import('./view/reserveRecord.vue'),
  meta: {
    requireAuth: false,
    routerAlive: true
  }
}]
export default routes